import styled, { keyframes } from 'styled-components';

const SKILLSIZES = {
  drilldown: 85,
} as const;

const sumSkillSizes = (skills: (keyof typeof SKILLSIZES)[]) => (
  skills.reduce((sum, skill) => sum + (SKILLSIZES[skill] ?? 0), 0)
);

const slideInOut = (max: number) => keyframes`
  0% { width: 0px; padding-left: 0px; }
  25% { width: ${max}px; padding-left: 15px; }
  75% { width: ${max}px; padding-left: 15px; }
  100% { width: 0px; padding-left: 0px; }
`;

export const SkillsInfoIcon = styled.div`
  display: flex;
  top: 2px;
  left: 2px;
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  & svg {
    fill: #212121;
    width: 20px;
    height: 20px;
    z-index: 2;
  }
  &:before {
    content: "";
    width: 16px;
    height: 16px;
    position: absolute;
    background-color: #EFBF04;
    z-index: 1;
    border-radius: 50%;
  }
`;

export const SkillAnimList = styled.div<{ skills: (keyof typeof SKILLSIZES)[] }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  top: 2px;
  left: 10px;
  position: absolute;
  height: 20px;
  width: 0;
  background-color: #212121E2;
  overflow: hidden;
  padding-left: 0;
  border-radius: 0;
  border-bottom-right-radius: 12% 50%;
  border-top-right-radius: 12% 50%;
  user-select: none;
  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto', arial, sans-serif;
    font-size: 12px;
    color: #EFBF04;
    & svg {
      fill: #EFBF04;
      height: 14px;
      width: 14px;
      margin-right: 3px;
    }
  }
  animation: ${({ skills }) => slideInOut(sumSkillSizes(skills))} 3s ease-in-out;
`;

export const SkillInfoPop = styled.div`
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto', arial, sans-serif;
    font-size: 12px;
    color: ${({ theme }) => theme.tooltipColor};
    & svg {
      fill: ${({ theme }) => theme.tooltipColor};
      height: 16px;
      width: 16px;
      margin-right: 3px;
    }
    & b {
      margin-right: 3px;
    }
  }
`;
